/*
 * Copyright 2018-present Evernote Corporation. All rights reserved.
 */

import BaseUrlUtil from 'ion-utils/lib/BaseUrlUtil';

export const getLoginEndpoint = () => {
  const encodedUrl = encodeURIComponent(window.location.href);
  return `${BaseUrlUtil.getBaseUrl()}Login.action?targetUrl=${encodedUrl}`;
};

export const getLogoutEndpoint = () => `${BaseUrlUtil.getBaseUrl()}Logout.action`;

export const getSSOInitializationEndpoint = () =>
  `${BaseUrlUtil.getBaseUrl()}business/BusinessSecurityLogin.action`;
